<template>
  <div class="flex items-center">
    <div class="grow border-t border-background-gray-subtle" />
    <div class="px-4 text-sm-12px-default text-text-subtlest">
      <slot />
    </div>
    <div class="grow border-t border-background-gray-subtle" />
  </div>
</template>
